<template>
  <div class="label-manage">
    <div class="title">标签管理</div>
    <div class="operations">
      <el-button @click="add" type="warning">新增标签</el-button>
    </div>
    <div class="list">
      <div class="item" v-for="(label, i) of labelList" :key="i">
        <div class="card">
          <div class="name">{{ label.labelName }}</div>
          <div class="icons">
            <i class="iconfont wyf-tianxie" @click="edit(label)"></i>
            <i class="iconfont wyf-shanchu" @click="remove(label)"></i>
          </div>
        </div>
        <div class="detail">
          <span>客户人数：{{ label.tenantCount || 0 }}</span>
          <span style="color: #fcbf0c; cursor: pointer" @click="toDetail(label)">详情</span>
        </div>
      </div>
    </div>
    <el-button @click="back">返回</el-button>
  </div>
  <el-dialog
    v-model="dialogVisible"
    title="添加客户标签"
    @close="handleDialogClose"
  >
    <el-form :model="labelForm" ref="labelForm" :rules="rules" v-if="dialogVisible">
      <el-form-item label="标签名称" prop="labelName">
        <el-input placeholder="请输入标签名称" v-model="labelForm.labelName" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="标签说明" prop="labelDescription">
        <el-input placeholder="请输入标签客户特征" v-model="labelForm.labelDescription" maxlength="100" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="cancelDialog">取消</el-button>
      <el-button type="warning" @click="confirmDialog">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Label",
  data() {
    return {
      labelList: [],
      dialogVisible: false,
      labelForm: {
        labelName: "",
        labelDescription: "",
      },
      rules: {
        labelName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
        ],
        labelDescription: [
          { required: true, message: '请输入标签客户特征', trigger: 'blur' },
        ],
      }
    };
  },
  methods: {
    ...mapActions(["fetchData"]),
    toDetail(label){
      this.$emit('changeActive', 'tenant');
      this.$eventBus.emit('labelIdChange', label.id);
    },
    handleDialogClose(){
      this.labelForm.labelName = "";
      this.labelForm.labelDescription = "";
    },
    edit(row) {
      this.labelForm = { ...row };
      this.dialogVisible = true;
    },
    remove(row) {
      this.$confirm(`确认删除「${row.labelName}」吗？`, "提示").then(() => {
        this.fetchData({
          url: "LABEL.DELETE",
          method: "post",
          headers: { "Content-Type": "application/json" },
          params: [row.id]
        }).then(() => {
          this.getLabelList()
          this.$message.success('删除成功')
        });
      })
    },
    add() {
      this.dialogVisible = true;
    },
    getLabelList() {
      this.fetchData({
        url: "LABEL.LIST",
        method: "get",
        headers: { "Content-Type": "application/json" },
      }).then(res => {
        this.labelList = res ? res.data : []
      });
    },
    confirmDialog(){
      this.$refs.labelForm.validate((valid) => {
        if(valid){
          this.fetchData({
            url: "LABEL.ADD",
            method: "post",
            headers: { "Content-Type": "application/json" },
            params: this.labelForm,
          }).then(() => {
            this.getLabelList();
            this.dialogVisible = false;
          });
        }
      })
    },
    cancelDialog(){
      this.dialogVisible = false;
      this.handleDialogClose();
    },
    back(){
      this.$emit('changeActive', 'tenant');
    },
  },
  created() {
    this.getLabelList();
  },
};
</script>

<style scoped lang="less">
.label-manage {
  color: black;
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  .title {
    font-size: 22px;
    margin-bottom: 8px;
  }
  .operations {
    margin-bottom: 8px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 244px;
      margin-right: 16px;
      margin-bottom: 16px;
      .card {
        display: flex;
        justify-content: space-between;
        border-radius: 8px;
        background: #ffffff;
        box-shadow: 1px 1px 2px 0px rgba(82, 90, 102, 0.04),
          2px 2px 8px 0px rgba(82, 90, 102, 0.08);
        padding: 50px 24px;
        margin-bottom: 8px;
        .name {
          font-size: 20px;
          font-weight: 600;
          color: #091136;
        }
        .icons {
          .iconfont {
            cursor: pointer;
            font-size: 16px;
          }
          .wyf-tianxie {
            margin-right: 20px;
          }
        }
      }
      .detail {
        display: flex;
        justify-content: space-between;
        padding: 0 8px;
      }
    }
  }
}
</style>
<style lang="less">
.el-dialog .el-dialog__body{
  min-height: 200px;
}
</style>